import React            from 'react';
import UiKit            from '../../../uikit';

class Icon extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    render(){
        let p = this.props;
        return(
            <div className={ `simprakit-dropdown-placeholder-icon` }>
                <UiKit.Icon icon={ p.icon } />
            </div>
        )
    }
}

export default Icon;